import * as jose from 'jose'

export const getDecryptedDataFromLocalStorage = async (key, defaultValue = {}) => {
  try {
    const data = window.localStorage.getItem(key)
    if (!data) return defaultValue

    const jwtKey = process.env.VUE_APP_JWT_KEY
    if (!jwtKey) {
      console.error('VUE_APP_JWT_KEY não está definida nas variáveis de ambiente')
      return defaultValue
    }

    const secret = new TextEncoder().encode(jwtKey)
    const { payload } = await jose.jwtVerify(data, secret)

    return payload
  } catch (error) {
    console.warn(`Erro ao verificar token ${key}:`, error.message)
    return defaultValue
  }
}
